import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  MenuItem, MenuItemText, Submenu, SubmenuContainer,
} from './css';

const ExpandMenuItem = (props) => {
  const { menuItem, handleSelection } = props;

  const [isExpanded, setExpanded] = useState(false);
  function handleSubmenu() {
    setExpanded(!isExpanded);
  }

  return (
    <MenuItem className={`panel-menuitem ${isExpanded ? 'is-active' : ''}`} hasChildren={!!menuItem.children} key={menuItem.value}>
      {/* eslint-disable-next-line react/jsx-no-bind */}
      <MenuItemText onClick={handleSubmenu}>{menuItem.value}</MenuItemText>
      <SubmenuContainer className={`panel-submenu ${isExpanded ? 'is-active' : ''}`}>
        <Submenu>
          {menuItem.children.map((subMenuItem) => (
            <MenuItem key={`subMenu-${subMenuItem.value}`}>
              <MenuItemText
                onClick={() => handleSelection({ code: subMenuItem.code, name: subMenuItem.value })}
              >
                {subMenuItem.value}
              </MenuItemText>
            </MenuItem>
          ))}
        </Submenu>
      </SubmenuContainer>
    </MenuItem>
  );
};

ExpandMenuItem.propTypes = {
  menuItem: PropTypes.shape({
    value: PropTypes.string,
    children: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string,
        code: PropTypes.string,
      }),
    ),
  }),
  handleSelection: PropTypes.func,
};

export default ExpandMenuItem;
